import {
  Checkbox as NextUICheckbox,
  type CheckboxProps as NextUICheckboxProps,
} from '@nextui-org/checkbox';

interface CheckboxProps extends NextUICheckboxProps {}

const Checkbox = (props: CheckboxProps) => {
  return (
    <NextUICheckbox
      disableAnimation
      color="danger"
      {...props}
    />
  );
};

export default Checkbox;
